import { hrApiClient } from '@/lib/api/clients';
import {
  submitFeedbackSchema,
  type SubmitFeedbackInput,
} from '@/shared/feedback';

export type { SubmitFeedbackInput };

export type SubmitFeedbackPayload = Omit<SubmitFeedbackInput, 'files'> & {
  files?: File[];
};

export async function submitFeedback(
  input: SubmitFeedbackPayload
): Promise<void> {
  const { files = [], companyId, ...fields } = input;
  const parsed = submitFeedbackSchema.parse({
    ...fields,
    ...(companyId && companyId > 0 ? { companyId } : {}),
    files: [],
  });

  const formData = new FormData();
  formData.append('projectId', String(parsed.projectId));
  const resolvedCompanyId = companyId ?? parsed.companyId ?? 0;
  if (resolvedCompanyId > 0) {
    formData.append('companyId', String(resolvedCompanyId));
  }
  formData.append('phone', String(parsed.phone));
  formData.append('catId', String(parsed.catId));
  formData.append('feedback', parsed.feedback);

  for (const file of files) {
    formData.append('files', file);
  }

  await hrApiClient.post('/feedback/create', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
